var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"codeToOpenid"},[_c('div',{staticClass:"pic_k"},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":""}}):_vm._e(),(_vm.outTime)?_c('div',{staticClass:"mask",on:{"click":_vm.init}},[_c('div',[_vm._v("二维码已过期")]),_c('div',{staticClass:"blue"},[_vm._v("点击刷新")])]):_vm._e()]),_c('div',{staticClass:"tip"},[_vm._v("微信扫码注册/登录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }